export interface LegacyUserData {
    self: string
    id: number
    clientId: number
    userAccountDeletionReasonId: number | null
    email: string
    username: string
    key: string
    newsletter: boolean
    currentPoints: number
    rankingGlobal: number
    rankingPerCountry: number
    rankingGlobalLastMonth: number
    rankingPerCountryLastMonth: number
    dateCreated: string
    dateUpdated: string
    dateDeleted: string | null
    firstName: string | null
    lastName: string | null
    avatar: string | null
    presentation: string | null
    banner: string | null
    birthday: string | null
    city: string | null
    website: string | null
    phone: string | null
    optin: boolean
    vehicleModelId: number | null
    vehicleVersionId: number | null
    latitude: number | null
    longitude: number | null
    slug: string
    contractId: number | null
    businessUnitId: string | null
    dateLastLogin: string | null
    dateLastLoginAttempt: string | null
    isChargemapPassOwner: boolean
    isChargemapPassUser: boolean
    isChargemapFleetUser: boolean
    isChargemapPlusUser: boolean
    hasFacebook: boolean
    hasApple: boolean
    hasGoogle: boolean
    hasPassword: boolean
    gender: string | null
    currentState: string
    currentLevel: string
    rank: string
    country: string | null
    locale: string
    phoneCountry: string | null
    defaultRfidPass: string | null
    points: string
    stateHistory: string
    chargingPoolPhotos: string
    chargingPoolFeedbacks: string
    rfidPasses: string
    charges: string
    discounts: string
    subscribe: string
    paymentMeans: string
    invoices: string
    passOrder: string
    ownedCars: string
    favorites: string
    defaultPaymentMean: string
    defaultVehicle: string | null
}

export interface UserAddress {
    firstName?: string
    name?: string
    company?: string
    addressLine1: string
    addressLine2?: string
    city: string
    postalCode: string
    countryName: string
    countryCode: string
    phone: string
    vatNumber?: string
    email?: string
}

export interface FeedbackUser {
    avatar: string | null
    id: number
    level: number
    rank: string
    slug: string
    username: string
}

export enum UserRank {
    MEMBER = 1,
    TRUSTED = 2,
    ADMIN = 3,
    AGENT = 4
}

export enum TeslaLinkStatus {
    INITIATED = 'INITIATED',
    CONFIRMED = 'CONFIRMED'
}
